import OAuthRedirect from '../_Auth/Pages/OAuthRedirect';
import ErrorPage from './Pages/ErrorPage';
import ShippingCalculator from '../ShippingCalculator/Pages/ShippingCalculator';
import { SuggestibleRouteInterface } from './Types/RouteTypes';

const PublicRoutes: Array<SuggestibleRouteInterface> = [
	{
		title: 'OAuth Callback',
		path: '/oauth-callback',
		element: <OAuthRedirect />,
		skipSuggestion: true,
	},
	{
		title: 'Shipping Calculator',
		path: '/shipping-calculator/:weight?/:width?/:height?/:depth?',
		element: <ShippingCalculator />,
	},
	{
		title: 'Error',
		path: '/error',
		element: <ErrorPage />,
		skipSuggestion: true,
	},
];

export { PublicRoutes };
